module.exports = __webpack_public_path__ + "static/img/rpaOpacidad.561a8b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rpaOpacidad.png
// module id = K5Ja
// module chunks = 9